import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { TipoImpresion } from './tipo-impresion.model';

@Injectable()
export class TipoImpresionResolver implements Resolve<TipoImpresion> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(TipoImpresion);
      }
      return await this.backendService.get(TipoImpresion, TipoImpresion.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/tipos-impresion']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/tipo-impresion/tipo-impresion.resolver.ts